import React from "react";
import {Button, Form, Input, Modal} from "antd";
import axios from '../pages/Common/axios';
import {postSaveUserInfo} from '../pages/Common/api';
import Cookies from 'js-cookie';

function PwChange({ onLogout, onClose }) {

    // 쿠키에서 사용자정보 값 가져오기
    const authUser = Cookies.get('auth_user');

    const onSubmit = (values) => {

        //새 비밀번호 확인
        if(values.new_password1 != values.new_password2) {
            Modal.error({title: "새 비밀번호가 일치하지 않습니다.", okText:"Close"});
            return;
        }
        //기존 비밀번호와 동일여부 확인
        if(values.old_password == values.new_password2) {
            Modal.error({title: "새 비밀번호가 기존 비밀번호와 동일합니다.", okText:"Close"});
            return;
        }
        //정규식 확인(숫자만 입력한 경우 오류)
        let check = /^[0-9]+$/;
        if (check.test(values.new_password1)) {
            Modal.error({title: "비밀번호는 숫자만으로 입력할 수 없습니다.", okText:"Close"});
            return;
        }

        if(values.old_password != '') {
            // 사용자 비밀번호 업데이트
            saveUserInfo(values);
        }
    };

    // 사용자 비밀번호 업데이트 API
    const saveUserInfo = (values) => {

        // 비밀번호 변경 요청(기존 비밀번호 체크로직 포함)
        axios.post(postSaveUserInfo(),
                            {username: authUser, 
                                old_password: values.old_password, 
                                new_password: values.new_password1,})
        .then((response) => {
            console.log("Password change response:", response.data);

            if(response.data == '000' || response.data === 'success' ||
               (response.data && response.data.success) ||
               response.status === 200) {
                onClose(); // 비밀번호 변경 모달 닫기
                Modal.success({
                    title: "비밀번호가 정상적으로 변경되었습니다.",
                    content: "비밀번호 변경이 완료되었습니다.",
                    okText:"확인"
                });
            } else {
                //기존 비밀번호가 일치하지 않습니다.
                const errorMessage = typeof response.data === 'string' ? response.data :
                                   (response.data && response.data.message) ? response.data.message :
                                   '비밀번호 변경에 실패했습니다.';
                Modal.info({title: errorMessage, okText:"Close"});
            }
        })
        .catch((error) => {
            //console.log(error);
            Modal.error({title: "로그인 사용자와 비밀번호를 확인하세요.", okText:"Close"});
        });
        
    };

    return (
        <div className='layer_overlay'>
            <div className='layer_wrap'>
                <Form   
                    name="basic"
                    labelCol={{span: 6,}}
                    wrapperCol={{span: 14,}}
                    style={{maxWidth: 600,}}
                    initialValues={{remember: true,}}
                    onFinish={onSubmit}
                    autoComplete="off"
                >
                    <Form.Item wrapperCol={{offset: 6, span: 14,}}>
                    </Form.Item>
                    <Form.Item label="기존 비밀번호" name="old_password"
                            rules={[{required: true,message: '현재 비밀번호를 입력하세요!',},]}
                            style={{fontSize:'14px', fontWeight:'bold'}}>
                        <Input.Password style={{height:'30px', fontSize:'14px'}}/>
                    </Form.Item>
                    <Form.Item label="새 비밀번호" name="new_password1" 
                            rules={[{required: true,message: '8자~20자로 새 비밀번호를 입력하세요!',min:8,max:20,},]}
                            style={{fontSize:'14px', fontWeight:'bold'}}>
                        <Input.Password style={{height:'30px', fontSize:'14px'}}/>
                    </Form.Item>
                    <Form.Item label="새 비밀번호(확인)" name="new_password2"
                            rules={[{required: true,message: '확인을 위하여 새 비밀번호를 동일하게 입력하세요!',min:8,max:20,},]}
                            style={{fontSize:'14px', fontWeight:'bold'}}>
                        <Input.Password style={{height:'30px', fontSize:'14px'}}/>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 8, }}>
                        <span>
                            <li>비밀번호는 8자 ~ 20자 이어야 합니다.</li>
                            <li>숫자로만 이루어진 비밀번호는 사용할 수 없습니다.</li>
                        </span>
                    </Form.Item>
                    <Form.Item wrapperCol={{offset: 8, span: 14,}}>
                        <Button type="primary" htmlType="submit">비밀번호 변경</Button>
                        <Button type="default" onClick={onClose}>Close</Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}

export default PwChange;